import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  const [open, setOpen] = useState(false);

  const navClass = ({ isActive }) =>
    `transition hover:text-amber-200 ${
      isActive ? "text-amber-300" : "text-stone-200"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-forest backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <div className="group">
          <Link
            to="/"
            className="text-2xl font-semibold tracking-[0.18em] text-white uppercase"
          >
            Cedar & Comb
          </Link>
          <div className="mt-2 text-xs tracking-[0.28em] text-stone-400 uppercase ">
            Hive Management · Queen Rearing · Nucs
          </div>
        </div>

        <button
          className="rounded-xl border border-white/10 px-3 py-2 text-sm text-stone-200 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          Menu
        </button>

        <nav className="hidden items-center gap-6 text-sm md:flex">
          <NavLink to="/" end className={navClass}>
            Home
          </NavLink>
          <NavLink to="/about" className={navClass}>
            About
          </NavLink>
          <NavLink to="/services" className={navClass}>
            Services
          </NavLink>
          <NavLink to="/contact" className={navClass}>
            Contact
          </NavLink>
          <Link
            to="/contact"
            className="rounded-full bg-amber-500 px-4 py-2 font-medium text-stone-950 transition hover:bg-amber-400"
          >
            Get in touch
          </Link>
        </nav>
      </div>

      {open && (
        <nav className="border-t border-white/10 bg-stone-950 px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4 text-sm">
            <NavLink
              to="/"
              end
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              About
            </NavLink>
            <NavLink
              to="/services"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Services
            </NavLink>
            <NavLink
              to="/contact"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Contact
            </NavLink>
          </div>
        </nav>
      )}
    </header>
  );
}
